import React, { useMemo, useState } from 'react';

import './Halan.scss';
import halanLogo from './../../../../../statics/img/halan/halan.png';
import { getErrorMsg } from '../../../../../utils/getErrorMsg';
import { confirmOTP, pay, sendOTP } from '../../../../services/halanService';
import Info from './steps/Info';
import Plans from './steps/Plans';
import OtpStep from './steps/OtpStep';
import { CONSTANTS } from './constants';
import Invoice from './components/Invoice';
import Error from './components/Error';
import Footer from './components/Footer';

const STEPS = {
  INFO: 0,
  PLANS: 1,
  OTP: 2,
};

function Halan({ payment_token }) {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(STEPS.INFO);
  const [plans, setPlans] = useState(null);
  const [orderAmount, setOrderAmount] = useState(null);
  const [transactionId, setTransactionId] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [phone, setPhone] = useState('');

  async function handlePay(nationalId) {
    setError('');
    setIsLoading(true);
    const res = await pay(nationalId, payment_token);

    if (res.status === 200) {
      const list = res.data.data.plans.map((plan) => ({
        id: plan.id,
        amount: plan.installmentAmount,
        months: plan.installmentPeriod,
        adminFees: plan.administrativeFees,
      }));
      setPlans(list);
      setTransactionId(res.data.id);
      setOrderAmount(
        (res.data.amount_cents / 100).toLocaleString('en-US', {
          minimumFractionDigits: 2,
        })
      );
      setCurrentStep(STEPS.PLANS);
    } else if (res.data.message === CONSTANTS.ERROR.NOT_REGISTERED) {
      setError(CONSTANTS.ERROR.NOT_REGISTERED_COMPONENT);
    } else {
      setError(getErrorMsg(res));
    }

    setIsLoading(false);
  }

  async function handleCheckout(planId) {
    setError('');
    setIsLoading(true);

    const res = await sendOTP(selectedPlan.id, transactionId, payment_token);

    if (res.status === 200) {
      setCurrentStep(STEPS.OTP);
    } else {
      setError(getErrorMsg(res));
      if (res.data && res.data.redirection_url) {
        setTimeout(() => {
          window.location.href = res.data.redirection_url;
        }, 3000);
      }
    }

    setIsLoading(false);
    return res.status;
  }

  async function handleOtpResend() {
    setError('');
    const status = await handleCheckout(selectedPlan.id);
    if (status === 200) return true;
  }

  async function handleConfirmOTP(otp) {
    setError('');
    setIsLoading(true);

    const res = await confirmOTP(otp, transactionId, payment_token);

    if (res.status === 400 && res.data.message === 'Invalid OTP') {
      setError(getErrorMsg(res));
    } else if (res.data && res.data.redirection_url) {
      window.location.href = res.data.redirection_url;
    } else {
      setError(getErrorMsg(res));
    }

    setIsLoading(false);
  }

  return (
    <div className="halan_page">
      <main className="halan_container">
        <Invoice orderAmount={orderAmount} plan={selectedPlan} />
        <div className="halan_content">
          <div className="halan_header">
            <div className="halan_header_content">
              <img
                className="halan_header_content_img"
                src={halanLogo}
                alt="halan"
              />
              <p className="halan_header_content_title">
                {CONSTANTS.GENERAL.TITLE}
              </p>
            </div>
          </div>

          {currentStep !== STEPS.INFO && <Error error={error} />}

          {currentStep === STEPS.INFO && (
            <Info onSubmit={handlePay} isLoading={isLoading} error={error} />
          )}

          {currentStep === STEPS.PLANS && (
            <Plans
              plans={plans}
              onSubmit={handleCheckout}
              isLoading={isLoading}
              selectedPlan={selectedPlan}
              setSelectedPlan={setSelectedPlan}
            />
          )}

          {currentStep === STEPS.OTP && (
            <OtpStep
              phoneNumber={phone}
              onOTPResend={handleOtpResend}
              onOTPSubmit={handleConfirmOTP}
              isLoading={isLoading}
            />
          )}

          <Footer />
        </div>
      </main>
    </div>
  );
}

export default Halan;
